import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "../../api/client";

export const fetchTerms = createAsyncThunk(
  "terms/fetchTerms",
  async (_, thunkApi) => {
    const res = await apiRequest("api/terms_and_conditions", { method: "GET" });

    if (!res.ok) {
      const errors = Array.isArray(res.data?.errors) ? res.data.errors : null;
      return thunkApi.rejectWithValue(
        errors?.join("\n") ||
          res.data?.message ||
          "Failed to load terms and conditions."
      );
    }

    return res.data || null;
  },
  {
    condition: (_, { getState }) => {
      const state = getState();
      const termsState = state?.terms;
      if (!termsState) return true;
      return termsState.status === "idle" || termsState.status === "failed";
    },
  }
);

const termsSlice = createSlice({
  name: "terms",
  initialState: {
    status: "idle", // idle | loading | succeeded | failed
    error: "",
    data: null,
  },
  reducers: {
    clearTerms(state) {
      state.status = "idle";
      state.error = "";
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTerms.pending, (state) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(fetchTerms.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = "";
        state.data = action.payload || null;
      })
      .addCase(fetchTerms.rejected, (state, action) => {
        state.status = "failed";
        state.error =
          typeof action.payload === "string"
            ? action.payload
            : "Failed to load terms and conditions.";
        state.data = null;
      });
  },
});

export const { clearTerms } = termsSlice.actions;
export default termsSlice.reducer;

